import { Image, FileText, Download } from "lucide-react";
import { Button } from "@/components/ui/button";

interface AttachmentPreviewProps {
  url: string;
  type: string;
}

const AttachmentPreview = ({ url, type }: AttachmentPreviewProps) => {
  if (!url) return null;

  const handleDownload = () => {
    window.open(url, "_blank");
  };

  if (type === "image") {
    return (
      <div className="mt-2 relative group">
        <img
          src={url}
          alt="مرفق"
          className="max-w-[200px] max-h-[150px] rounded-lg object-cover cursor-pointer hover:opacity-90 transition-opacity"
          onClick={handleDownload}
        />
        <Button
          variant="secondary"
          size="icon"
          className="absolute top-2 left-2 opacity-0 group-hover:opacity-100 transition-opacity h-7 w-7"
          onClick={handleDownload}
        >
          <Download className="w-3 h-3" />
        </Button>
      </div>
    );
  }

  return (
    <div
      className="mt-2 flex items-center gap-2 bg-secondary/50 rounded-lg p-3 cursor-pointer hover:bg-secondary transition-colors"
      onClick={handleDownload}
    >
      <FileText className="w-5 h-5 text-primary" />
      <span className="text-sm text-foreground">
        {type === "pdf" ? "ملف PDF" : "مستند"}
      </span>
      <Download className="w-4 h-4 text-muted-foreground mr-auto" />
    </div>
  );
};

export default AttachmentPreview;
